import { CustomError } from './custom-error.js';

export interface RpcServerErrorInfo {
  errorId: string;
  traceId?: string;
  statusCode: number;
}

export class RpcServerError extends CustomError {
  readonly errorId: string;
  readonly traceId?: string;
  readonly statusCode: number;

  constructor(message: string, info: RpcServerErrorInfo) {
    super(message, {
      errorId: info.errorId,
      traceId: info.traceId ?? null,
      statusCode: info.statusCode.toString(),
    });
    this.errorId = info.errorId;
    this.traceId = info.traceId;
    this.statusCode = info.statusCode;
  }
}
